module.exports = __webpack_public_path__ + "static/media/routes03.5d7ad89f.webp";